<template>
  <div class="gs-portal-join-page">
    <v-wait for="loginChecking">
      <div slot="waiting">
        <div class="gs-portal-join-page__waiting">
          {{ $t('frontend_resources_connecting', {appTitle: whitelabelAppData('sell').title}) }}
        </div>
      </div>
      <div v-if="isUserSignedUpToAffiliateProgram">
        <promo-tools-assets
          @userLoggedOut="userLoggedOut"
        />
      </div>
      <div v-else-if="membershipChecked || membershipError" class="gs-portal-join-page__card-wrap">
        <section class="gs-portal-join-page__card">
          <p class="gs-portal-join-page__eyebrow">Affiliate portal</p>
          <h1 class="gs-portal-join-page__title">
            {{ membershipError ? 'Unable to check your affiliate access' : 'Join this affiliate program' }}
          </h1>
          <p class="gs-portal-join-page__text">
            You’re logged in to Groove. Join this program to get your affiliate links and the vendor’s promotion tools.
          </p>
          <p v-if="membershipError" role="alert">{{ membershipError }}</p>
          <p v-if="joinError" role="alert">{{ joinError }}</p>
          <div>
            <gs-button v-if="membershipError" variant="primary" @click="checkFunnelAffiliate()">Try again</gs-button>
            <gs-button v-else variant="primary" :disabled="joining" @click="signupToPromoteFunnel()">
              {{ joining ? 'Joining…' : 'Join Affiliate Program' }}
            </gs-button>
          </div>
        </section>
      </div>
    </v-wait>
  </div>
</template>

<script>
import axios from 'axios';
import FunnelAffiliate from '@/models/FunnelAffiliate';
import Cookies from 'js-cookie';
import PromoToolsAssets from './promo_tools_assets';

export default {
  name: 'PromoToolsPostLogin',
  components: {
    PromoToolsAssets,
  },
  props: {
    funnelId: {
      required: true,
    },
  },
  data() {
    return {
      isUserSignedUpToAffiliateProgram: 0,
      membershipChecked: false,
      membershipError: '',
      joinError: '',
      joining: false,
    };
  },
  async created() {
    await this.checkFunnelAffiliate();
  },
  methods: {
    async checkFunnelAffiliate() {
      this.$wait.start('loginChecking');
      this.membershipError = '';
      this.membershipChecked = false;
      try {
        const { data } = await axios.get(`check-if-funnel-affiliate/${this.funnelId}`);
        if (!data || !['success', 'error'].includes(data.status)) throw new Error('Unexpected response');
        this.isUserSignedUpToAffiliateProgram = data.status === 'success' ? 1 : 0;
        this.membershipChecked = true;
      } catch (_) {
        this.isUserSignedUpToAffiliateProgram = 0;
        this.membershipError = 'We could not verify your access. Please try again.';
      } finally {
        this.$wait.end('loginChecking');
      }
    },
    userLoggedOut() {
      this.$emit('userLoggedOut', 1);
    },
    async signupToPromoteFunnel() {
      if (this.joining) return;
      this.joining = true;
      this.joinError = '';
      this.$loader.start('signupToPromoteFunnel');

      const funnelAffiliate = new FunnelAffiliate({});
      funnelAffiliate.funnel_id = this.funnelId;

      const gdJvCookie = Cookies.get(`gd_jv_f${this.funnelId}`);

      if (typeof gdJvCookie !== 'undefined') {
        funnelAffiliate.gd_jv_cookie = gdJvCookie;
      }

      const gsJvCookie = Cookies.get(`gs_jv_f${this.funnelId}`);

      if (typeof gsJvCookie !== 'undefined') {
        funnelAffiliate.gs_jv_cookie = gsJvCookie;
      }

      try {
        await funnelAffiliate.save();
        await this.checkFunnelAffiliate();
        if (!this.isUserSignedUpToAffiliateProgram && !this.membershipError) {
          this.joinError = 'Your affiliate access is not active yet. Please try again or contact the vendor.';
        }
      } catch (_) {
        this.joinError = 'We could not join the program. Please try again.';
      } finally {
        this.joining = false;
        this.$loader.end('signupToPromoteFunnel');
      }
    },
  },
};
</script>

<style scoped>
.gs-portal-join-page {
  min-width: 0;
  color: var(--gs-foreground);
}

.gs-portal-join-page__waiting {
  padding: 32px 20px;
  color: var(--gs-muted-foreground);
  font-size: 15px;
  font-weight: 600;
  text-align: center;
}

.gs-portal-join-page__card-wrap {
  display: flex;
  justify-content: center;
  padding: 28px 20px;
}

.gs-portal-join-page__card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 560px;
  min-width: 0;
  padding: 24px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gs-portal-join-page__eyebrow {
  margin: 0;
  color: var(--gs-primary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.gs-portal-join-page__title {
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
}

.gs-portal-join-page__text {
  margin: 0 0 6px;
  color: var(--gs-muted-foreground);
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 560px) {
  .gs-portal-join-page__card-wrap {
    padding: 16px 12px;
  }

  .gs-portal-join-page__card {
    padding: 18px;
  }
}
</style>
